module.exports = __webpack_public_path__ + "img/43_28.29326166.png";